import { render } from "./NotFoundPage.vue?vue&type=template&id=33213050"
import script from "./NotFoundPage.vue?vue&type=script&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&lang=js"

import "./NotFoundPage.vue?vue&type=style&index=0&id=33213050&lang=scss"

import exportComponent from "C:\\xampp8\\htdocs\\AI4IRGClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__